import React from 'react';
import { AdsInfoProps } from '@/interfaces';
import { FieldValues, UseFormRegister } from 'react-hook-form';
import { InputRadio } from '@/components/form';
import Image from 'next/image';
import clsx from 'clsx';
import { Icon } from '@/components/common';
import Icons from '@/const/icons';

interface Props {
	image: string;
	index: number;
	imageSelected: {
		image: string;
		index: number;
	};
	adsCurrentInfo?: AdsInfoProps | undefined;
	isSelectedByDefault?: boolean;
	register: UseFormRegister<FieldValues>;
	className?: string;
	onClick: () => void;
	handleAddImage: () => void;
}

export const ImageComponent: React.FC<Props> = ({
	image,
	index,
	register,
	onClick,
	className,
	imageSelected,
	handleAddImage,
	isSelectedByDefault,
}) => {
	const isSelected = isSelectedByDefault || imageSelected?.index === index;

	return (
		<div className={clsx('relative w-[124px] h-[124px]', className)}>
			<InputRadio
				name={`ai-image-${index}`}
				checked={isSelected}
				value={index}
				register={register}
				className="absolute top-1 -right-2 z-10"
				onChange={handleAddImage}
			/>
			<Image
				src={image}
				width={124}
				height={124}
				sizes="124px"
				alt="image"
				className="object-cover !size-[124px]"
				quality={100}
				unoptimized
			/>
			<div
				className={clsx(
					'absolute inset-0 bg-black opacity-0 transition-opacity hover:opacity-60'
				)}
			>
				<button
					type="button"
					className="top-[35%] right-[35%] absolute p-2 rounded-lg"
					onClick={onClick}
				>
					<Icon src={Icons.galleryEdit} className="!size-6 !text-white" />
				</button>
			</div>
		</div>
	);
};
